<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'material/index' }">
                                Bahan Ajar
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'material/subject', params: {gradeID: gradeSubject.gradeID} }">
                                {{ gradeSubject.grade.name  }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ gradeSubject.subject.name  }}
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col mb-3">
                <h3>
                    {{ gradeSubject.grade.name  }} - {{ gradeSubject.subject.name  }}
                </h3>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-4">
                <div id="table-primary" class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr class="text-danger font-weight-bold">
                                <th scope="col">
                                    Tanggal
                                </th>
                                <th scope="col">
                                    Nomor Siswa
                                </th>
                                <th scope="col">
                                    Name
                                </th>
                                <th scope="col">
                                    Kelas
                                </th>
                                <th scope="col">
                                    Cabang
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="shadow-sm" v-for="log in logs" v-bind:key="log.id">
                                <td>
                                    {{ [log.createdAt, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY | HH:mm") }}
                                </td>
                                <td>
                                    {{ log.user.student.identity }}
                                </td>
                                <td>
                                    {{ log.user.name }}
                                </td>
                                <td>
                                    {{ log.user.student.btaGrade.name }}
                                </td>
                                <td>
                                    {{ log.user.student.branch.name }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 mb-4">
                <nav class="float-right">
                    <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                    </paginate>
                </nav>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "MaterialSubjectLog",
        data() {
            return {
                gradeSubject: {subject: {}, grade: {}},
                logs: [],
                pageCount: 0,
                page: 1
            };
        },
        methods: {
            paginate(page, scroll = true) {
                this.axios.get(process.env.API_URL + '/teaching-material/' + this.$route.params.type + '/' + this.$route.params.reference + '/logs', {params: {page: page}}).then(response => {
                    this.logs = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;

                    if (scroll) {
                        document.getElementById('table-primary').scrollIntoView();
                        var headerElement = document.getElementsByTagName('nav');
                        if (headerElement.length) {
                            window.scrollBy(0, headerElement[0].offsetHeight * -1);
                        }
                    }
                });
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/grade-subject/' + this.$route.params.gradeSubjectID).then(response => {
                this.gradeSubject = response.data.data;
            });
            this.paginate(1, false);
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/material/Log.vue